import { FC, lazy, memo, Suspense, useCallback, useEffect, useMemo, useRef, useState } from "react";
import { Redirect, Route, BrowserRouter as Router, Switch } from "react-router-dom";

import { Icon } from "./components/icon";
import { Page404 } from "./pages/404";
import { AccountPage } from "./pages/account";
import { DocumentPage } from "./pages/document";
import { DocumentTemplatePage } from "./pages/document/template";
import { DocumentViewPage } from "./pages/document/view";
import { HomePage } from "./pages/home";
import { LandingPage2 } from "./pages/landing2";
import { NotifyPage } from "./pages/notify/components";
import { ITCodeGrantedPage } from "./pages/procedure/it-code-granted";
import { ITCodeGrantedApprovalHistoryPage } from "./pages/procedure/it-code-granted/approval-history";
import { ITCodeGrantedCreatePage } from "./pages/procedure/it-code-granted/create";
import { ItCodeGrantedDetailPage } from "./pages/procedure/it-code-granted/detail";
import { LeaveRequestPage } from "./pages/procedure/leave-request";
import { LeaveRequestApprovalHistoryPage } from "./pages/procedure/leave-request/approval-history";
import { LeaveRequestCreatePage } from "./pages/procedure/leave-request/create";
import { LeaveRequestDetailPage } from "./pages/procedure/leave-request/detail";
import { MyLeaveRequestPage } from "./pages/procedure/leave-request/my-leave-request-detail";
import { ProcedureMeetingPage } from "./pages/procedure/meeting";
import { ProcedureMeetingCreatePage } from "./pages/procedure/meeting/create";
import { ProcedureMeetingDetailPage } from "./pages/procedure/meeting/detail";
import { ProcedureTrainingPage } from "./pages/procedure/training";
import { ProcedureTrainingCourseCreatePage } from "./pages/procedure/training/course/create";
import { ProcedureTrainingCoursePage } from "./pages/procedure/training/course/training-course";
import { ProcedureTrainingCourseDetailPage } from "./pages/procedure/training/course/training-course-detail";
import { ProcedureTrainingStudentPage } from "./pages/procedure/training/course/training-course-trainee";
import { ProcedureTrainingPlanCreatePage } from "./pages/procedure/training/plan/create";
import { ProcedureTrainingPlanPage } from "./pages/procedure/training/plan/training-plan";
import { ProcedureTrainingPlanDetailPage } from "./pages/procedure/training/plan/training-plan-detail";
import { SettingDocumentPage } from "./pages/setting/document";
import { SettingDocumentDepartmentPage } from "./pages/setting/document/document-department/document-department";
import { SettingDocumentTypePage } from "./pages/setting/document/document-type/document-type";
import { SettingGroupPage } from "./pages/setting/document/group/group";
import { SettingDocumentPermissionPage } from "./pages/setting/document/permission/document-permission";

//Import Process
import { ProcedureAccountingPage } from "./pages/procedure/Accounting";
import { procedureAdvanceOfferPage } from "./pages/procedure/Accounting/Advance/advance-list";
import { procedureCollaborateTicket as procedureCollaborateTicketV2 } from "./pages/procedure/company-office/business-tickets-v2/list-business";
import { procedureCollaborateTicket } from "./pages/procedure/company-office/business-tickets/list-business";
import { officialVehicleDetailPage } from "./pages/procedure/company-office/request-vehicle/.officialVehicleDetail";
import { createOfficialVehiclePage } from "./pages/procedure/company-office/request-vehicle/create-official-vehicle";
import { officialVehicleListPage } from "./pages/procedure/company-office/request-vehicle/list-vehicle";
import { procedureIssuingLongTermSecurityControlCard } from "./pages/procedure/company-office/sercurity-control-card/list";
import { createApplicationForLeave } from "./pages/procedure/department-process/application-for-leave/create-application-for-leave";
import { procedureApplicationForLeave } from "./pages/procedure/department-process/application-for-leave/list-application-for-leave";
import { createPauseLaborContract } from "./pages/procedure/department-process/pause-labor-contract/create-pause-labor-contract";
import { procedurePauseLaborContract } from "./pages/procedure/department-process/pause-labor-contract/list-labor-contract";
import { procedureMove } from "./pages/procedure/department-process/process-move/list-move";
import { createProcessCodeVmsNewPage } from "./pages/procedure/info-technology-process/code-process/create-list-code-vms";
import { processCodeGrantedDetailPage } from "./pages/procedure/info-technology-process/code-process/processCodeDetail";
import { createDeleteUserAccount } from "./pages/procedure/info-technology-process/delete-user-account/create-delete";
import { deleteUserAccountDetailPage } from "./pages/procedure/info-technology-process/delete-user-account/deleteAccountDetail";
import { procedureDeleteUserAccount } from "./pages/procedure/info-technology-process/delete-user-account/list-delete";
import { processEprDetailPage } from "./pages/procedure/info-technology-process/epr-process/.processEprDetail";
import { createProcessEprPage } from "./pages/procedure/info-technology-process/epr-process/create-process-epr";
import { procedureProcessEpr } from "./pages/procedure/info-technology-process/epr-process/list-process-epr";
import { createRepairToolsPage } from "./pages/procedure/info-technology-process/repair-tools/create-repair-tools";
import { procedureRepairTools } from "./pages/procedure/info-technology-process/repair-tools/list-repair-tool";
import { repairITToolDetailPage } from "./pages/procedure/info-technology-process/repair-tools/repairToolDetail";
import { createToolTechnologyPage } from "./pages/procedure/info-technology-process/tool-technology/create-tool-technology";
import { itToolDetailPage } from "./pages/procedure/info-technology-process/tool-technology/ITToolDetails";
import { procedureProcessToolTechnology } from "./pages/procedure/info-technology-process/tool-technology/list-tool";
import { ProcedureSafePage } from "./pages/procedure/Safe/Index";
import { proceduredocumentAccessPage } from "./pages/procedure/Safe/safe/safe-list";
// Document
import { StatisticDocumentPage } from "./pages/statistics/statistics-document/statisticDocument";
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import PageWarning from "./components/pageWarning/PageWarning";
import DiagramPage from "./pages/document/components/diagram/diagram";
import { businessTicketDetail as businessTicketDetailV2 } from "./pages/procedure/company-office/business-tickets-v2/businessTicketDetail";
import { businessTicketDetail } from "./pages/procedure/company-office/business-tickets/businessTicketDetail";
import { createBusinessTicket } from "./pages/procedure/company-office/business-tickets/create-business-ticket";
import { createBusinessTicket as createBusinessTicketV2 } from "./pages/procedure/company-office/business-tickets-v2/create-business-ticket";
import { createSercurityCardUnitsPage } from "./pages/procedure/company-office/securityCardUnits/create";
import { ProcessSecurityControlCardsToExternalUnits } from "./pages/procedure/company-office/securityCardUnits/list";
import { detailSecurityCardUnitsPage } from "./pages/procedure/company-office/securityCardUnits/securityCardUnitsDetail";
import { createProcedureSecurityControlCardPage } from "./pages/procedure/company-office/sercurity-control-card/create";
import { sercurityConTrolCardDetailPage } from "./pages/procedure/company-office/sercurity-control-card/securityControlCardDetail";
import { createBusinessVehicleCardPage } from "./pages/procedure/company-office/vehicle-travel-card/create";
import { businessVehicleCardPage } from "./pages/procedure/company-office/vehicle-travel-card/list";
import { detailBusinessVeCardPage } from "./pages/procedure/company-office/vehicle-travel-card/vehicleTravelCardDetail";
import { createDemandForSuppliesPage } from "./pages/procedure/info-technology-process/demand-for-supplies/create-demand-for-supplies";
import { demandForSuppliesDetailPage } from "./pages/procedure/info-technology-process/demand-for-supplies/demandForSupplyDetail";
import { procedureDemandForSupplies } from "./pages/procedure/info-technology-process/demand-for-supplies/list-demand-for-supplies";
import { StatisticDistributionDocumentPage } from "./pages/statistics/distribution-document/distribution-document";
import { StatisticDocumentByViagsPage } from "./pages/statistics/document-by-viags/statistic-document-viags";
import { FeaturedInfo } from "./pages/statistics/feature-info";
import { QuoteStatisticDocumentPage } from "./pages/statistics/quote-document/quote-statistic-document";
import { StatisticReadDocumentDetailPage } from "./pages/statistics/statistic-read-document/statistic-read-detail";
import { store, useSelector } from "./store/store";
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { useMsal } from "@azure/msal-react";
import { message, Spin } from "antd";
import { BubbleChat } from "./components/bubble-chat/bubble-chat";
import { ForbiddenPage } from "./components/config-forbidden";
import FullscreenLoading from "./components/loading/fullscreen-loading";
import PERMISSIONS from "./constants/permissions";
import { BUSINESS_TICKETS_VERSION } from "./constants/version";
import { useMineInfo } from "./contexts/mine-info-context";
import { useUser } from "./hook";
import Permission from "./hook/Permission";
import { chatsRoutes } from "./pages/chat";
import { ViagsGptPageRoutes } from "./pages/ChatAIPage";
import { ConfigProcedure } from "./pages/config";
import { DocumentDetailPage } from "./pages/document/detail";
import { DetailRequestTable } from "./pages/landing2/DetailRequestTable";
import { LadingDocumentPage } from "./pages/landing2/LandingDocument";
import { createBusinessExternalVehicleCardPage } from "./pages/procedure/company-office/external-vehicle-travel-card/create";
import { detailExternalBusinessVeCardPage } from "./pages/procedure/company-office/external-vehicle-travel-card/ExternalVehicleTravelDetail";
import { externalBusinessVehicleCardPage } from "./pages/procedure/company-office/external-vehicle-travel-card/list";
import { MeetingRequest } from "./pages/procedure/company-office/meeting-request";
import { Create as CreateMeetingRequest } from "./pages/procedure/company-office/meeting-request/pages/create";
import { Detail as DetailMeetingRequest } from "./pages/procedure/company-office/meeting-request/pages/detail";
import { Edit as EditMeetingRequest } from "./pages/procedure/company-office/meeting-request/pages/edit";
import { companyOfficeRoutes } from "./pages/procedure/company-office/routes";
import DashboardPage from "./pages/procedure/dashboard";
import CompanyOfficeStatisticPage from "./pages/procedure/dashboard/company-office-statistic";
import ITStatisticPage from "./pages/procedure/dashboard/it-statistic";
import AbsenceLetterNoSalary from "./pages/procedure/human-organization/absence-letter-tsn/pages/application-no-salary";
import { NoSalaryTSNCreate } from "./pages/procedure/human-organization/absence-letter-tsn/pages/application-no-salary/letter-salary-create";
import { NoSalaryTSNEdit } from "./pages/procedure/human-organization/absence-letter-tsn/pages/application-no-salary/letter-salary-edit";
import AbsenceLetterSuppendContract from "./pages/procedure/human-organization/absence-letter-tsn/pages/application-suspend-contrast";
import { SuspendApplicationTSNCreate } from "./pages/procedure/human-organization/absence-letter-tsn/pages/application-suspend-contrast/letter-suspend-create";
import { SuspendContrastTSNEdit } from "./pages/procedure/human-organization/absence-letter-tsn/pages/application-suspend-contrast/letter-suspend-edit";
import AbsenceLetterTerminateContract from "./pages/procedure/human-organization/absence-letter-tsn/pages/application-terminate-contrast";
import { TerminationContractCreateTSN } from "./pages/procedure/human-organization/absence-letter-tsn/pages/application-terminate-contrast/letter-terminate-create";
import { TerminationContractEditTSN } from "./pages/procedure/human-organization/absence-letter-tsn/pages/application-terminate-contrast/letter-terminate-edit";
import AbsenceLetterDetail from "./pages/procedure/human-organization/absence-letter/pages/absence-letter/absence-letter-detail";
import {
  applicationForLeaveDADRoutes,
  applicationForLeaveNBARoutes,
  humanOrganizationRoutes,
} from "./pages/procedure/human-organization/routes";
import { procedureProcessVms } from "./pages/procedure/info-technology-process/code-process/list-code";
import { renewProcessCodeVmsNewPage } from "./pages/procedure/info-technology-process/code-process/renew-list-code-vms";
import { renewDeleteUserAccount } from "./pages/procedure/info-technology-process/delete-user-account/renew-delete";
import { renewDemandForSuppliesPage } from "./pages/procedure/info-technology-process/demand-for-supplies/renew-demand-for-supplies";
import { renewProcessEprPage } from "./pages/procedure/info-technology-process/epr-process/renew-process-epr";
import { renewRepairToolsPage } from "./pages/procedure/info-technology-process/repair-tools/renew-repair-tools";
import { planningDepartmentRoutes } from "./pages/procedure/process-recommend-department/routes";
import DepartmentsPage from "./pages/setting/departments";
import { SettingDecentralizationPageV2 } from "./pages/setting/document/decentralization/decentralization-user-v2";
import { useSettingsPermission } from "./pages/setting/document/decentralization/hooks/use-settings-permission";
import { documentTagsBox } from "./pages/setting/document/document-tags/components/document-tags-box";
import { VersionDocumentContent } from "./pages/statistics/version-content/version-content";
import { UserService } from "./services/user/user.service";
// import { Permission as NPPermission } from "./pages/permission";
// import { PERMISSIONS } from "./pages/role-control/constants";
// import NotAllowed from "./components/error/not-allowed";

const StatisticAbsenceLetterPage = lazy(() => import("./pages/procedure/statistic-absence-letter/list"));
const PermissionLookupList = lazy(
  () => import("./pages/procedure/info-technology-process/permission-lookup/permission-lookup-list"),
);
const ModifyPermissionLookup = lazy(
  () => import("./pages/procedure/info-technology-process/permission-lookup/modify-permission-lookup"),
);
const PermissionLookupDetail = lazy(
  () => import("./pages/procedure/info-technology-process/components/permission-lookup/permission-lookup-detail"),
);
const ModifyProcedurePermissionLookup = lazy(
  () =>
    import("./pages/procedure/info-technology-process/procedure-permission-lookup/modify-procedure-permission-lookup"),
);

const ProcedurePermissionLookupDetail = lazy(
  () =>
    import("./pages/procedure/info-technology-process/components/procedure-permission-lookup/procedure-permission-lookup-detail"),
);
const ProcedurePermissionLookupManagement = lazy(
  () =>
    import("./pages/procedure/info-technology-process/procedure-permission-lookup/procedure-permission-lookup-list"),
);
const AccessPermissionLookup = lazy(
  () => import("./pages/procedure/info-technology-process/access-permission-lookup/index"),
);

export const Routes: any = {
  home: {
    path: "/",
    // component: LandingPage,
    component: LandingPage2,
    isAdmin: false,
    title: "Home",
  },
  ladingDocument: {
    path: "/landing-document",
    component: LadingDocumentPage,
    isAdmin: false,
    title: "Home",
  },
  details: {
    path: "/home/details",
    // component: LandingPage,
    component: DetailRequestTable,
    isAdmin: false,
    title: "Home Details",
  },
  category: {
    path: "/category",
    component: HomePage,
    isAdmin: false,
    title: "Category",
  },
  warning: {
    path: "/warning",
    component: PageWarning,
    isAdmin: false,
    title: "warning",
  },

  account: {
    path: "/account",
    component: AccountPage,
    isAdmin: false,
    title: "Account",
  },

  // Absence no salary TSN
  absenceNoSalary: {
    isAdmin: false,
    title: "2. Nghỉ không lương",
    path: "/procedure/no-salary-leave-tsn",
    component: () => {
      return (
        <AbsenceLetterNoSalary />

        // <NPPermission record={{ [PERMISSIONS["NO_SALARY_LEAVE_TSN"]]: ({ R }) => R }} fallback={<NotAllowed />}>
        //   <AbsenceLetterNoSalary />
        // </NPPermission>
      );
    },
  },
  absenceNoSalaryCreate: {
    isAdmin: false,
    path: "/procedure/no-salary-leave-tsn/create",
    parentId: "procedure",
    component: NoSalaryTSNCreate,
  },

  detailAbsenceLetterPageTSNRoute: {
    isAdmin: false,
    path: "/procedure/no-salary-leave-tsn/:applicationForLeaveId",
    parentId: "procedure",
    component: AbsenceLetterDetail,
  },
  editAbsenceLetterPageTSNRoute: {
    isAdmin: false,
    path: "/procedure/no-salary-leave-tsn/:applicationForLeaveId/edit",
    parentId: "procedure",
    component: NoSalaryTSNEdit,
  },

  // Suspend Constract TSN
  absenceSuspendConstract: {
    isAdmin: false,
    title: "3. Đơn xin tạm hoãn HĐLĐ",
    path: "/procedure/suspend-contract-tsn",
    component: () => {
      return (
        <AbsenceLetterSuppendContract />

        // <NPPermission record={{ [PERMISSIONS["SUSPEND_CONTRACT_TSN"]]: ({ R }) => R }} fallback={<NotAllowed />}>
        //   <AbsenceLetterSuppendContract />
        // </NPPermission>
      );
    },
  },

  createAbsenceSuspendLetterPageTSN: {
    isAdmin: false,
    path: "/procedure/suspend-contract-tsn/create",
    parentId: "procedure",
    component: SuspendApplicationTSNCreate,
  },
  detailAbsenceSuspendLetterPageTSN: {
    isAdmin: false,
    path: "/procedure/suspend-contract-tsn/:applicationForLeaveId",
    parentId: "procedure",
    component: AbsenceLetterDetail,
  },
  editAbsenceSuspendLetterPageTSN: {
    isAdmin: false,
    path: "/procedure/suspend-contract-tsn/:applicationForLeaveId/edit",
    parentId: "procedure",
    component: SuspendContrastTSNEdit,
  },

  // Terminate Constract TSN
  absenceTerminateConstract: {
    isAdmin: false,
    title: "4. Đơn xin chấm dứt HĐLĐ",
    path: "/procedure/termination-contract-tsn",
    component: () => {
      return (
        <AbsenceLetterTerminateContract />

        // <NPPermission record={{ [PERMISSIONS["TERMINATION_CONTRACT_TSN"]]: ({ R }) => R }} fallback={<NotAllowed />}>
        //   <AbsenceLetterTerminateContract />
        // </NPPermission>
      );
    },
  },

  // Thống kê nghỉ phép theo phòng
  statisticAbsenceLetterPage: {
    isAdmin: false,
    title: "5. Thống kê nghỉ phép theo phòng",
    path: "/procedure/statistic-absence-letter",
    parentId: "procedure",
    component: StatisticAbsenceLetterPage,
  },

  createTerminationContractTSNPage: {
    isAdmin: false,
    path: "/procedure/termination-contract-tsn/create",
    parentId: "procedure",
    component: TerminationContractCreateTSN,
  },
  detailTerminationContractTSNPage: {
    isAdmin: false,
    path: "/procedure/termination-contract-tsn/:applicationForLeaveId",
    parentId: "procedure",
    component: AbsenceLetterDetail,
  },
  editTerminationContractTSNPage: {
    isAdmin: false,
    path: "/procedure/termination-contract-tsn/:applicationForLeaveId/edit",
    parentId: "procedure",
    component: TerminationContractEditTSN,
  },

  // Procedure
  procedure: {
    isAdmin: false,
    title: "Quy trình văn phòng điện tử",
    path: "/procedure",
    icon: <Icon.Procedure />,
    component: () => <Redirect to={Routes.procedureProcessEpr.path} />,
  },
  procedureLeaveRequest: {
    isAdmin: false,
    title: "Xin nghỉ",
    icon: <Icon.Time />,
    path: "/procedure/leave-request",
    parentId: "procedure",
    component: LeaveRequestPage,
  },
  procedureMyLeaveRequest: {
    isAdmin: false,
    title: "Lịch sử nghỉ phép",
    icon: <Icon.Time />,
    path: "/procedure/my-leave-request",
    parentId: "procedure",
    component: MyLeaveRequestPage,
  },
  procedureLeaveRequestApprovalHistory: {
    isAdmin: false,
    title: "Lịch sử duyệt",
    icon: <Icon.Time />,
    path: "/procedure/leave-request-approval-history",
    parentId: "procedure",
    component: LeaveRequestApprovalHistoryPage,
  },
  procedureLeaveRequestCreateNew: {
    isAdmin: false,
    title: "Tạo mới đơn",
    path: "/procedure/leave-request/new/:id",
    parentId: "procedure",
    component: LeaveRequestCreatePage,
  },
  procedureLeaveRequestDetail: {
    isAdmin: false,
    title: "Chi tiết đơn xin nghỉ phép",
    path: "/procedure/leave-request/:id",
    parentId: "procedure",
    component: LeaveRequestDetailPage,
  },
  procedureItCodeGranted: {
    isAdmin: false,
    title: "Quản lí tài khoản",
    icon: <Icon.CodeApplication />,
    path: "/procedure/it-code-granted",
    parentId: "procedure",
    component: ITCodeGrantedPage,
  },
  procedureItCodeGrantedApprovalHistory: {
    isAdmin: false,
    title: "Xem lịch sử duyệt",
    icon: <Icon.CodeApplication />,
    path: "/procedure/it-code-granted-approval-history",
    parentId: "procedure",
    component: ITCodeGrantedApprovalHistoryPage,
  },
  procedureItCodeGrantedCreateNew: {
    path: "/procedure/it-code-granted/new/:id",
    parentId: "procedure",
    component: ITCodeGrantedCreatePage,
  },
  procedureItCodeGrantedDetail: {
    path: "/procedure/it-code-granted/:id",
    parentId: "procedure",
    component: ItCodeGrantedDetailPage,
  },
  procedureMeeting: {
    isAdmin: false,
    title: "Họp",
    path: "/procedure/meeting",
    icon: <Icon.Meeting />,
    parentId: "procedure",
    component: ProcedureMeetingPage,
  },
  procedureMeetingCreate: {
    isAdmin: false,
    title: "Họp",
    path: "/procedure/meeting/new/:id",
    icon: <Icon.Meeting />,
    parentId: "procedure",
    component: ProcedureMeetingCreatePage,
  },
  procedureMeetingDetail: {
    isAdmin: false,
    title: "Họp",
    path: "/procedure/meeting/:id",
    icon: <Icon.Meeting />,
    parentId: "procedure",
    component: ProcedureMeetingDetailPage,
  },
  procedureTraining: {
    isAdmin: false,
    title: "Đào tạo",
    path: "/procedure/training",
    icon: <Icon.DisplayCompany />,
    parentId: "procedure",
    component: ProcedureTrainingPage,
  },
  procedureTrainingPlan: {
    isAdmin: false,
    title: "1. Kế hoạch đào tạo",
    path: "/procedure/training-plan",
    icon: <Icon.CustomerGroup />,
    parentId: "procedure",
    component: ProcedureTrainingPlanPage,
  },
  procedureTrainingPlanCreate: {
    isAdmin: false,
    title: "Tạo kế hoạch",
    path: "/procedure/training-plan/plan/new/:id",
    icon: <Icon.CustomerGroup />,
    parentId: "procedure",
    component: ProcedureTrainingPlanCreatePage,
  },
  procedureTrainingPlanDetail: {
    isAdmin: false,
    title: "Chi tiết kế hoạch",
    path: "/procedure/training-plan/plan/detail/:plancode/:id",
    icon: <Icon.CustomerGroup />,
    parentId: "procedure",
    component: ProcedureTrainingPlanDetailPage,
  },
  procedureTrainingCourse: {
    isAdmin: false,
    title: "2. Quản lý lớp học",
    path: "/procedure/training-course",
    icon: <Icon.CustomerGroup />,
    parentId: "procedure",
    component: ProcedureTrainingCoursePage,
  },
  procedureTrainingStudent: {
    isAdmin: false,
    title: "3. Quản lý học viên",
    path: "/procedure/training-course-trainee",
    icon: <Icon.CustomerGroup />,
    parentId: "procedure",
    component: ProcedureTrainingStudentPage,
  },
  procedureTrainingCourseCreate: {
    isAdmin: false,
    title: "Tạo lớp học",
    path: "/procedure/training-plan/course/new/:plancode/:id",
    icon: <Icon.CustomerGroup />,
    parentId: "procedure",
    component: ProcedureTrainingCourseCreatePage,
  },
  procedureTrainingCourseDetail: {
    isAdmin: false,
    title: "Chi tiết lớp học",
    path: "/procedure/training-plan/course/detail/:id",
    icon: <Icon.CustomerGroup />,
    parentId: "procedure",
    component: ProcedureTrainingCourseDetailPage,
  },
  procedureTrainingCourseStudentDetail: {
    isAdmin: false,
    title: "Chi tiết lớp học",
    path: "/procedure/training-course-trainee/detail/:id",
    icon: <Icon.CustomerGroup />,
    parentId: "procedure",
    component: ProcedureTrainingCourseDetailPage,
  },
  //Routes technology

  //Info technology process
  processCodeGrantedDetailPage: {
    path: "/procedure/it-program-granted/details/:id",
    parentId: "procedure",
    component: processCodeGrantedDetailPage,
  },
  processEprDetailPage: {
    path: "/procedure/sabre-epr-granted/details/:id",
    parentId: "procedure",
    component: processEprDetailPage,
  },
  procedureDetailEprCreateNew: {
    path: "/procedure/info-technology-process/sabre-epr-granted/new/:id",
    parentId: "procedure",
    component: createProcessEprPage,
  },
  procedureDetailEprCreateRenew: {
    path: "/procedure/info-technology-process/sabre-epr-granted/renew/:id",
    parentId: "procedure",
    component: renewProcessEprPage,
  },
  createProcessEprPage: {
    isAdmin: false,
    title: "Tạo mới",
    path: "/procedure/sabre-epr-granted/new/:id",
    icon: <Icon.Checked />,
    parentId: "procedure",
    component: createProcessEprPage,
  },
  renewProcessEprPage: {
    isAdmin: false,
    title: "Tạo mới",
    path: "/procedure/sabre-epr-granted/renew/:id",
    icon: <Icon.Checked />,
    parentId: "procedure",
    component: renewProcessEprPage,
  },
  createProcessCodeVmsNewPage: {
    isAdmin: false,
    title: "Tạo mới",
    path: "/procedure/it-program-granted/new/:id",
    icon: <Icon.Checked />,
    parentId: "procedure",
    component: createProcessCodeVmsNewPage,
  },
  renewProcessCodeVmsNewPage: {
    isAdmin: false,
    title: "Tạo mới",
    path: "/procedure/it-program-granted/renew/:id",
    icon: <Icon.Checked />,
    parentId: "procedure",
    component: renewProcessCodeVmsNewPage,
  },

  procedureProcess: {
    isAdmin: false,
    title: "CÔNG NGHỆ THÔNG TIN",
    path: "/procedure/info-technology-process",
    icon: <Icon.DisplayCompany />,
    parentId: "procedure",
    component: ProcedureTrainingPage,
  },
  procedureProcessEpr: {
    isAdmin: false,
    title: "Cấp/Thay Đổi/Xoá Code Amadeus",
    path: "/procedure/sabre-epr-granted",
    icon: <Icon.Checked />,
    parentId: "procedure",
    component: () => {
      const ProcedureProcessEpr = procedureProcessEpr;
      return (
        <ProcedureProcessEpr />

        // <NPPermission record={{ [PERMISSIONS["SABRE_EPR_GRANTED"]]: ({ R }) => R }} fallback={<NotAllowed />}>
        //   <ProcedureProcessEpr />
        // </NPPermission>
      );
    },
  },
  procedureProcessVms: {
    isAdmin: false,
    title: "Cấp Quyền SD Chương Trình",
    path: "/procedure/it-program-granted",
    icon: <Icon.CustomerGroup />,
    parentId: "procedure",
    component: () => {
      const ProcedureProcessVms = procedureProcessVms;
      return (
        <ProcedureProcessVms />

        // <NPPermission record={{ [PERMISSIONS["IT_PROGRAM_GRANTED"]]: ({ R }) => R }} fallback={<NotAllowed />}>
        //   <ProcedureProcessVms />
        // </NPPermission>
      );
    },
  },
  permissionLookupManagement: {
    isAdmin: false,
    title: "Cấp quyền sử dụng chương trình",
    path: "/procedure/permission-lookup-management",
    icon: <Icon.CustomerGroup />,
    parentId: "procedure",
    component: PermissionLookupList,
  },
  modifyPermissionLookup: {
    path: "/procedure/permission-lookup-management/modify/:id",
    parentId: "procedure",
    component: ModifyPermissionLookup,
  },
  duplicatePermissionLookup: {
    path: "/procedure/permission-lookup-management/duplicate/:id",
    parentId: "procedure",
    component: ModifyPermissionLookup,
  },
  permissionLookupDetail: {
    path: "/procedure/permission-lookup-management/details/:id",
    parentId: "procedure",
    component: PermissionLookupDetail,
  },
  myPermissionLookupDetail: {
    path: "/procedure/permission-lookup-management/my-details/:id",
    parentId: "procedure",
    component: PermissionLookupDetail,
  },

  // HỦY QUYỀN SỬ DỤNG CHƯƠNG TRÌNH
  procedurePermissionLookupManagement: {
    isAdmin: false,
    title: "Hủy quyền sử dụng chương trình",
    path: "/procedure/procedure-permission-lookup-management",
    icon: <Icon.CustomerGroup />,
    parentId: "procedure",
    component: ProcedurePermissionLookupManagement,
  },
  modifyProcedurePermissionLookup: {
    path: "/procedure/procedure-permission-lookup-management/modify/:id",
    parentId: "procedure",
    component: ModifyProcedurePermissionLookup,
  },
  duplicateProcedurePermissionLookup: {
    path: "/procedure/procedure-permission-lookup-management/duplicate/:id",
    parentId: "procedure",
    component: ModifyProcedurePermissionLookup,
  },
  procedurePermissionLookupDetail: {
    path: "/procedure/procedure-permission-lookup-management/details/:id",
    parentId: "procedure",
    component: ProcedurePermissionLookupDetail,
  },
  myProcedurePermissionLookupDetail: {
    path: "/procedure/procedure-permission-lookup-management/my-details/:id",
    parentId: "procedure",
    component: ProcedurePermissionLookupDetail,
  },

  // Tra cứu quyền cấp
  accessPermissionLookup: {
    isAdmin: false,
    title: "Tra cứu quyền cấp",
    path: "/procedure/access-permission-lookup",
    icon: <Icon.CustomerGroup />,
    parentId: "procedure",
    component: AccessPermissionLookup,
  },

  procedureProcessToolTechnology: {
    isAdmin: false,
    title: "Cấp Công Cụ CNTT",
    path: "/procedure/it-tool-granted",
    icon: <Icon.CustomerGroup />,
    parentId: "procedure",
    component: procedureProcessToolTechnology,
  },
  procedureDeleteUserAccount: {
    isAdmin: false,
    title: "Xóa Tài Khoản",
    path: "/procedure/account-delete-granted",
    icon: <Icon.CustomerGroup />,
    parentId: "procedure",
    component: () => {
      const ProcedureDeleteUserAccount = procedureDeleteUserAccount;
      return (
        <ProcedureDeleteUserAccount />

        // <NPPermission record={{ [PERMISSIONS["ACCOUNT_DELETE_GRANTED"]]: ({ R }) => R }} fallback={<NotAllowed />}>
        //   <ProcedureDeleteUserAccount />
        // </NPPermission>
      );
    },
  },
  createDeleteUserAccount: {
    isAdmin: false,
    title: "Tạo mới",
    path: "/procedure/account-delete-granted/new/:id",
    icon: <Icon.Checked />,
    parentId: "procedure",
    component: createDeleteUserAccount,
  },
  renewDeleteUserAccount: {
    isAdmin: false,
    title: "Tạo mới",
    path: "/procedure/account-delete-granted/renew/:id",
    icon: <Icon.Checked />,
    parentId: "procedure",
    component: renewDeleteUserAccount,
  },
  deleteUserAccountDetailPage: {
    path: "/procedure/account-delete-granted/details/:id",
    parentId: "procedure",
    component: deleteUserAccountDetailPage,
  },
  createToolTechnologyPage: {
    isAdmin: false,
    title: "Tạo yêu cầu công cụ muốn cấp",
    path: "/procedure/it-tool-granted/new/:id",
    icon: <Icon.CustomerGroup />,
    parentId: "procedure",
    component: createToolTechnologyPage,
  },

  procedureRepairTools: {
    isAdmin: false,
    title: "Sửa Chữa CNTT",
    path: "/procedure/repair-tool-granted",
    icon: <Icon.CustomerGroup />,
    parentId: "procedure",
    component: () => {
      const ProcedureRepairTools = procedureRepairTools;
      return (
        <ProcedureRepairTools />

        // <NPPermission record={{ [PERMISSIONS["REPAIR_TOOL_GRANTED"]]: ({ R }) => R }} fallback={<NotAllowed />}>
        //   <ProcedureRepairTools />
        // </NPPermission>
      );
    },
  },

  createRepairTools: {
    isAdmin: false,
    title: "Tạo mới",
    path: "/procedure/repair-tool-granted/new/:id",
    icon: <Icon.Checked />,
    parentId: "procedure",
    component: createRepairToolsPage,
  },
  renewRepairTools: {
    isAdmin: false,
    title: "Tạo mới",
    path: "/procedure/repair-tool-granted/renew/:id",
    icon: <Icon.Checked />,
    parentId: "procedure",
    component: renewRepairToolsPage,
  },
  itToolDetailPage: {
    path: "/procedure/it-tool-granted/details/:id",
    parentId: "procedure",
    component: itToolDetailPage,
  },
  repairITToolDetailPage: {
    path: "/procedure/repair-tool-granted/details/:id",
    parentId: "procedure",
    component: repairITToolDetailPage,
  },
  procedureDemandForSupplies: {
    isAdmin: false,
    title: "Nhu Cầu Cấp Vật Tư, CCDC CNTT",
    path: "/procedure/demand-for-supplies",
    icon: <Icon.CustomerGroup />,
    parentId: "procedure",
    component: () => {
      const ProcedureDemandForSupplies = procedureDemandForSupplies;
      return (
        <ProcedureDemandForSupplies />

        // <NPPermission record={{ [PERMISSIONS["DEMAND_FOR_SUPPLIES"]]: ({ R }) => R }} fallback={<NotAllowed />}>
        //   <ProcedureDemandForSupplies />
        // </NPPermission>
      );
    },
  },
  createDemandForSuppliesPage: {
    isAdmin: false,
    title: "Tạo yêu cầu công cụ muốn cấp",
    path: "/procedure/demand-for-supplies/new/:id",
    icon: <Icon.CustomerGroup />,
    parentId: "procedure",
    component: createDemandForSuppliesPage,
  },
  renewDemandForSuppliesPage: {
    isAdmin: false,
    title: "Tạo yêu cầu công cụ muốn cấp",
    path: "/procedure/demand-for-supplies/renew/:id",
    icon: <Icon.CustomerGroup />,
    parentId: "procedure",
    component: renewDemandForSuppliesPage,
  },
  demandForSuppliesDetailPage: {
    isAdmin: false,
    title: "chi tiết công cụ muốn cấp",
    path: "/procedure/demand-for-supplies/details/:id",
    parentId: "procedure",
    component: demandForSuppliesDetailPage,
  },

  // procedure statistics

  statisticsPage: {
    isAdmin: false,
    title: "Dashboard",
    path: "/procedure/statistics",
    parentId: "procedure",
    component: DashboardPage,
  },
  ITstatisticPage: {
    isAdmin: false,
    title: "Thống kê phòng CNTT",
    path: "/procedure/statistics/information-technology",
    parentId: "procedure",
    component: ITStatisticPage,
  },
  companyOfficeStatisticPage: {
    isAdmin: false,
    title: "Thống kê VPCT",
    path: "/procedure/statistics/company-office",
    parentId: "procedure",
    component: CompanyOfficeStatisticPage,
  },

  //procedure config
  ConfigProcedure: {
    isAdmin: false,
    title: "Cấu hình văn phòng điện tử",
    path: "/procedure/config",
    parentId: "procedure",
    component: ConfigProcedure,
  },

  //Procedure safe dept
  procedureSafe: {
    isAdmin: false,
    title: "Phòng An toàn",
    path: "/procedure/Safe",
    icon: <Icon.Checked />,
    parentId: "procedure",
    component: ProcedureSafePage,
  },
  documentAccess: {
    isAdmin: false,
    title: "1. Truy cập tài liệu",
    path: "/procedure/Document-access",
    icon: <Icon.Checked />,
    parentId: "procedure",
    component: proceduredocumentAccessPage,
  },

  proceduredocumentAccessCreate: {
    isAdmin: false,
    title: "Tạo mới",
    path: "/procedure/Document-access/new/:id",
    icon: <Icon.Checked />,
    parentId: "procedure",
    component: ITCodeGrantedCreatePage,
  },

  promulgatingEditDoc: {
    isAdmin: false,
    title: "2. Ban hành, chỉnh sửa tài liệu",
    path: "/procedure/promulgating-Edit",
    icon: <Icon.Checked />,
    parentId: "procedure",
    component: procedureAdvanceOfferPage,
  },

  procedurepromulgatingEditDocCreate: {
    isAdmin: false,
    title: "Tạo mới",
    path: "/procedure/promulgating-Edit/new/:id",
    icon: <Icon.Checked />,
    parentId: "procedure",
    component: ITCodeGrantedCreatePage,
  },
  //Procedure Accounting Dept
  procedureAccounting: {
    isAdmin: false,
    title: "Phòng Kế toán",
    path: "/procedure/Accouting",
    icon: <Icon.Checked />,
    parentId: "procedure",
    component: ProcedureAccountingPage,
  },

  procedureAdvanceOffer: {
    isAdmin: false,
    title: "1. Tạm ứng",
    path: "/procedure/Advance-offer",
    icon: <Icon.Checked />,
    parentId: "procedure",
    component: procedureAdvanceOfferPage,
  },

  procedureAdvanceOfferCreate: {
    isAdmin: false,
    title: "Tạo mới",
    path: "/procedure/Advance-offer/new/:id",
    icon: <Icon.Checked />,
    parentId: "procedure",
    component: ITCodeGrantedCreatePage,
  },
  procedureAssetHandover: {
    isAdmin: false,
    title: "2. Biên bản bàn giao tài sản",
    path: "/procedure/Asset-handover",
    icon: <Icon.Checked />,
    parentId: "procedure",
    component: procedureAdvanceOfferPage,
  },

  procedureAssetHandoverCreate: {
    isAdmin: false,
    title: "Tạo mới",
    path: "/procedure/Asset-handover/new/:id",
    icon: <Icon.Checked />,
    parentId: "procedure",
    component: ITCodeGrantedCreatePage,
  },

  //Office Process
  procedureOfficeProcess: {
    isAdmin: false,
    title: "VĂN PHÒNG CÔNG TY",
    path: "/procedure/business-vehicle",
    icon: <Icon.Clipboard />,
    parentId: "procedure",
    component: officialVehicleListPage,
  },
  // Dùng trong một component (Bao gồm Màn Hình list, tạo, chi tiết)
  officialVehicleListPage: {
    isAdmin: false,
    title: "6. Sử Dụng Xe Công Vụ",
    path: "/procedure/business-vehicle",
    icon: <Icon.Checked />,
    parentId: "procedure",
    component: () => {
      const OfficialVehicleListPage = officialVehicleListPage;
      return (
        <OfficialVehicleListPage />

        // <NPPermission record={{ [PERMISSIONS["BUSINESS_VEHICLE"]]: ({ R }) => R }} fallback={<NotAllowed />}>
        //   <OfficialVehicleListPage />
        // </NPPermission>
      );
    },
  },
  createOfficialVehiclePage: {
    isAdmin: false,
    title: "Tạo đề nghị xin xe công vụ",
    path: "/procedure/business-vehicle/new/:id",
    icon: <Icon.CustomerGroup />,
    parentId: "procedure",
    component: createOfficialVehiclePage,
  },
  officialVehicleDetailPage: {
    isAdmin: false,
    title: "chi tiết",
    path: "/procedure/business-vehicle/details/:id",
    parentId: "procedure",
    component: officialVehicleDetailPage,
  },
  // Kết thúc một quy trình
  ...companyOfficeRoutes,
  procedureCollaborateTicket: {
    isAdmin: false,
    title: "1. Cấp/Hoàn Vé Công Tác",
    path: "/procedure/business-tickets",
    icon: <Icon.Tickets />,
    parentId: "procedure",
    component: () => {
      let ProcedureCollaborateTicket = procedureCollaborateTicket;

      if (BUSINESS_TICKETS_VERSION === 2) ProcedureCollaborateTicket = procedureCollaborateTicketV2;

      return (
        <ProcedureCollaborateTicket />

        // <NPPermission record={{ [PERMISSIONS["BUSINESS_TICKETS"]]: ({ R }) => R }} fallback={<NotAllowed />}>
        //   <ProcedureCollaborateTicket />
        // </NPPermission>
      );
    },
  },
  createProcedureCollaborateTicket: {
    isAdmin: false,
    title: "Tạo cấp vé công tác",
    path: "/procedure/business-tickets/new/:id",
    icon: <Icon.CustomerGroup />,
    parentId: "procedure",
    component: BUSINESS_TICKETS_VERSION === 1 ? createBusinessTicket : createBusinessTicketV2,
  },
  duplicateProcedureCollaborateTicket: {
    isAdmin: false,
    title: "Tạo cấp vé công tác",
    path: "/procedure/business-tickets/duplicate/:id",
    icon: <Icon.CustomerGroup />,
    parentId: "procedure",
    component: BUSINESS_TICKETS_VERSION === 1 ? createBusinessTicket : createBusinessTicketV2,
  },
  procedureCollaborateTicketDetailPage: {
    path: "/procedure/business-tickets/details/:id",
    parentId: "procedure",
    component: BUSINESS_TICKETS_VERSION === 1 ? businessTicketDetail : businessTicketDetailV2,
  },
  myProcedureCollaborateTicketDetailPage: {
    path: "/procedure/business-tickets/my-details/:id",
    parentId: "procedure",
    component: BUSINESS_TICKETS_VERSION === 1 ? businessTicketDetail : businessTicketDetailV2,
  },

  securityControlCardIssuance: {
    isAdmin: false,
    title: "2. Cấp Thẻ KSAN Cho Nội Bộ VIAGS",
    path: "/procedure/security-control-card",
    icon: <Icon.CustomerGroup />,
    parentId: "procedure",
    component: () => {
      const ProcedureIssuingLongTermSecurityControlCard = procedureIssuingLongTermSecurityControlCard;
      return (
        <ProcedureIssuingLongTermSecurityControlCard />

        // <NPPermission record={{ [PERMISSIONS["SECURITY_CONTROL_CARD"]]: ({ R }) => R }} fallback={<NotAllowed />}>
        //   <ProcedureIssuingLongTermSecurityControlCard />
        // </NPPermission>
      );
    },
  },
  createProcedureSecurityControlCardPage: {
    isAdmin: false,
    title: "Tạo đề nghị xin xe công vụ",
    path: "/procedure/security-control-card/new/:id",
    icon: <Icon.CustomerGroup />,
    parentId: "procedure",
    component: createProcedureSecurityControlCardPage,
  },
  //Kết thúc
  //Cấp thẻ KSAN cho đơn vị bên ngoài
  ProcessSecurityControlCardsToExternalUnits: {
    isAdmin: false,
    title: "3. Cấp Thẻ KSAN Cho Đơn Vị Bên Ngoài",
    path: "/procedure/security-cards-to-external-entities",
    icon: <Icon.CustomerGroup />,
    parentId: "procedure",
    component: () => {
      return (
        <ProcessSecurityControlCardsToExternalUnits />

        // <NPPermission record={{ [PERMISSIONS["SECURITY_CARDS_EXTERNAL"]]: ({ R }) => R }} fallback={<NotAllowed />}>
        //   <ProcessSecurityControlCardsToExternalUnits />
        // </NPPermission>
      );
    },
  },
  createSercurityCardUnitsPage: {
    isAdmin: false,
    title: "Tạo cấp thẻ KSAN cho đơn vị ngoài",
    path: "/procedure/security-cards-to-external-entities/new/:id",
    icon: <Icon.CustomerGroup />,
    parentId: "procedure",
    component: createSercurityCardUnitsPage,
  },
  detailSercurityCardUnitsPage: {
    isAdmin: false,
    title: "Chi tiết cấp thẻ KSAN",
    path: "/procedure/security-control-card/details/:id",
    icon: <Icon.CustomerGroup />,
    parentId: "procedure",
    component: sercurityConTrolCardDetailPage,
  },
  detailExternalSercurityCardUnitsPage: {
    isAdmin: false,
    title: "Chi tiết cấp thẻ KSAN cho đơn vị ngoài",
    path: "/procedure/security-cards-to-external-entities/details/:id",
    icon: <Icon.CustomerGroup />,
    parentId: "procedure",
    component: detailSecurityCardUnitsPage,
  },
  //Cấp thẻ phương tiện
  businessVehicleCardPage: {
    isAdmin: false,
    title: "4. Cấp Giấy Phép KSAN Cho Phương Tiện VIAGS",
    path: "/procedure/business-vehicle-card",
    icon: <Icon.CustomerGroup />,
    parentId: "procedure",
    component: () => {
      const BusinessVehicleCardPage = businessVehicleCardPage;
      return (
        <BusinessVehicleCardPage />

        // <NPPermission record={{ [PERMISSIONS["BUSINESS_VEHICLE_CARD"]]: ({ R }) => R }} fallback={<NotAllowed />}>
        //   <BusinessVehicleCardPage />
        // </NPPermission>
      );
    },
  },
  createBusinessVehicleCardPage: {
    isAdmin: false,
    title: "Tạo Cấp Giấy Phép KSAN Cho Phương Tiện VIAGS",
    path: "/procedure/business-vehicle-card/new/:id",
    icon: <Icon.CustomerGroup />,
    parentId: "procedure",
    component: createBusinessVehicleCardPage,
  },
  detailBusinessVeCardPage: {
    isAdmin: false,
    title: "chi tiết",
    path: "/procedure/business-vehicle-card/details/:id",
    icon: <Icon.CustomerGroup />,
    parentId: "procedure",
    component: detailBusinessVeCardPage,
  },
  // Cấp thẻ phương tiện cho đơn vị ngoài
  businessVehicleCardPageToExternal: {
    isAdmin: false,
    title: "5. Cấp Giấy Phép KSAN Cho Đơn Vị Ngoài",
    path: "/procedure/external-business-vehicle-card",
    icon: <Icon.CustomerGroup />,
    parentId: "procedure",
    component: () => {
      const ExternalBusinessVehicleCardPage = externalBusinessVehicleCardPage;
      return (
        <ExternalBusinessVehicleCardPage />

        // <NPPermission
        //   record={{ [PERMISSIONS["EXTERNAL_BUSINESS_VEHICLE_CARD"]]: ({ R }) => R }}
        //   fallback={<NotAllowed />}
        // >
        //   <ExternalBusinessVehicleCardPage />
        // </NPPermission>
      );
    },
  },
  createBusinessVehicleCardPageToExternal: {
    isAdmin: false,
    title: "Tạo yêu cầu cấp giấy phép KSAN cho đơn vị ngoài",
    path: "/procedure/external-business-vehicle-card/new/:id",
    icon: <Icon.CustomerGroup />,
    parentId: "procedure",
    component: createBusinessExternalVehicleCardPage,
  },
  detailBusinessVeCardPageToExternal: {
    isAdmin: false,
    title: "chi tiết",
    path: "/procedure/external-business-vehicle-card/details/:id",
    icon: <Icon.CustomerGroup />,
    parentId: "procedure",
    component: detailExternalBusinessVeCardPage,
  },
  // yêu cầu phòng họp
  meetingRequestPage: {
    isAdmin: false,
    title: "7. Đăng ký và sử dụng phòng họp",
    path: "/procedure/meeting-request",
    icon: <Icon.Checked />,
    parentId: "procedure",
    component: MeetingRequest,
  },
  meetingRequestCreatePage: {
    isAdmin: false,
    path: "/procedure/meeting-request/create/:id",
    parentId: "procedure",
    component: CreateMeetingRequest,
  },
  meetingRequestDetailPage: {
    isAdmin: false,
    path: "/procedure/meeting-request/detail/:id",
    parentId: "procedure",
    component: DetailMeetingRequest,
  },
  meetingRequestEditPage: {
    isAdmin: false,
    path: "/procedure/meeting-request/edit/:id",
    component: EditMeetingRequest,
  },
  //Recommend the planning department
  ...planningDepartmentRoutes,
  //Resources Department Process
  createApplicationForLeave: {
    isAdmin: false,
    title: "Tạo mới đơn",
    path: "/procedure/info-technology-process/new/:id",
    parentId: "procedure",
    component: createApplicationForLeave,
  },
  procedureResourcesDepartmentProcess: {
    isAdmin: false,
    title: "Phòng Nhân Sự",
    path: "/procedure/department-process",
    icon: <Icon.Checked />,
    parentId: "procedure",
    component: ProcedureTrainingPage,
  },
  procedureApplicationForLeave: {
    isAdmin: false,
    title: "1. Đơn Xin Nghỉ Phép",
    path: "/procedure/create-application-for-leave",
    icon: <Icon.Checked />,
    parentId: "procedure",
    component: () => {
      const ProcedureApplicationForLeave = procedureApplicationForLeave;
      return (
        <ProcedureApplicationForLeave />

        // <NPPermission record={{ [PERMISSIONS["ABSENCE_LETTER"]]: ({ R }) => R }} fallback={<NotAllowed />}>
        //   <ProcedureApplicationForLeave />
        // </NPPermission>
      );
    },
  },
  procedurePauseLaborContract: {
    isAdmin: false,
    title: "2. Đơn Xin Tạm Hoãn Hợp Đồng Lao Động",
    path: "/procedure/create-labor-contract",
    icon: <Icon.CustomerGroup />,
    parentId: "procedure",
    component: procedurePauseLaborContract,
  },
  createPauseLaborContract: {
    isAdmin: false,
    title: "Tạo mới đơn",
    path: "/procedure/pause-labor-contract/new/:id",
    icon: <Icon.CustomerGroup />,
    parentId: "procedure",
    component: createPauseLaborContract,
  },
  procedureMove: {
    isAdmin: false,
    title: "3. Đơn Xin Điều Chuyển",
    path: "/procedure/create-move",
    icon: <Icon.CustomerGroup />,
    parentId: "procedure",
    component: procedureMove,
  },

  ...humanOrganizationRoutes,
  ...applicationForLeaveNBARoutes,
  ...applicationForLeaveDADRoutes,

  // Document
  document: {
    isAdmin: false,
    title: "Quản lý văn bản",
    path: "/document",
    icon: <Icon.Compose />,
    component: DocumentPage,
  },
  documentDiagram: {
    isAdmin: false,
    title: "Biêu đổ",
    path: "/document/content/:id/diagram",
    icon: <Icon.DragPoint />,
    component: DiagramPage,
  },
  documentDetail: {
    isAdmin: false,
    title: "Thông tin tài liệu",
    path: "/document/detail/:id",
    parentId: "document",
    component: DocumentDetailPage,
  },
  documentTemplate: {
    isAdmin: false,
    title: "Soạn thảo tài liệu mẫu",
    path: "/document/template/:id",
    parentId: "document",
    component: DocumentTemplatePage,
  },
  documentView: {
    isAdmin: false,
    title: "Xem tài liệu đã soạn thảo",
    path: "/document/view/:id",
    parentId: "document",
    component: DocumentViewPage,
  },
  notify: {
    isAdmin: false,
    title: "Notify",
    path: "/document-notify",
    component: NotifyPage,
  },
  //Statistics
  statistic: {
    // isAdmin: true,
    title: "Thống kê",
    path: "/statistic",
    icon: <Icon.Category />,
    parentId: "statistic",
    component: () => (
      <Permission
        role={["admin", "statistic"]}
        permissions={[PERMISSIONS.STATISTICS_DOCUMENT_DEPLOYMENT]}
        fallback={<ForbiddenPage />}
      >
        <FeaturedInfo />
      </Permission>
    ),
  },
  statistics: {
    // isAdmin: true,
    title: "Tổng quan",
    path: "/statistic",
    icon: <Icon.Category />,
    parentId: "statistic",
    component: () => (
      <Permission
        permissions={[PERMISSIONS.STATISTICS_DOCUMENT_DEPLOYMENT]}
        role={["admin", "statistic"]}
        fallback={<ForbiddenPage />}
      >
        <FeaturedInfo />
      </Permission>
    ),
  },
  userDocument: {
    // isAdmin: true,
    title: "Tình trạng tài liệu",
    path: "/statistic-document",
    icon: <Icon.Compose />,
    component: () => (
      <Permission
        permissions={[PERMISSIONS.STATISTICS_DOCUMENT_DEPLOYMENT]}
        role={["admin", "statistic"]}
        fallback={<ForbiddenPage />}
      >
        <StatisticDocumentPage />
      </Permission>
    ),
  },
  readStatisticDocument: {
    // isAdmin: true,
    title: "Số lượng/tỷ lệ người đã đọc tài liệu",
    path: "/statistic-user-read-document",
    icon: <Icon.Compose />,
    component: () => (
      <Permission
        permissions={[PERMISSIONS.STATISTICS_DOCUMENT_DEPLOYMENT]}
        role={["admin", "statistic"]}
        fallback={<ForbiddenPage />}
      >
        <StatisticReadDocumentDetailPage />
      </Permission>
    ),
  },
  statisticDocumentByViagsPage: {
    // isAdmin: true,
    title: "Số lượng tài liệu của Viags",
    path: "/document-by-viags",
    icon: <Icon.Compose />,
    component: () => (
      <Permission role={["admin", "statistic"]} fallback={<ForbiddenPage />}>
        <StatisticDocumentByViagsPage />
      </Permission>
    ),
  },
  statisticDistributionDocumentPage: {
    // isAdmin: true,
    title: "Danh sách phân phối tài liệu",
    path: "/statistic-distribution-document",
    icon: <Icon.Compose />,
    component: () => (
      <Permission
        permissions={[PERMISSIONS.STATISTICS_DOCUMENT_DEPLOYMENT]}
        role={["admin", "statistic"]}
        fallback={<ForbiddenPage />}
      >
        <StatisticDistributionDocumentPage />
      </Permission>
    ),
  },
  quoteStatisticDocumentPage: {
    // isAdmin: true,
    title: "Văn bản tài liệu viện dẫn",
    path: "/statistic-quote-document",
    icon: <Icon.Compose />,
    component: () => (
      <Permission
        permissions={[PERMISSIONS.STATISTICS_DOCUMENT_DEPLOYMENT]}
        role={["admin", "statistic"]}
        fallback={<ForbiddenPage />}
      >
        <QuoteStatisticDocumentPage />
      </Permission>
    ),
  },
  versionDocumentContentPage: {
    // isAdmin: true,
    title: "Thống kê nội dung sửa đổi",
    path: "/version-document-content",
    icon: <Icon.Compose />,
    component: () => (
      <Permission
        permissions={[PERMISSIONS.STATISTICS_DOCUMENT_DEPLOYMENT]}
        role={["admin", "statistic"]}
        fallback={<ForbiddenPage />}
      >
        <VersionDocumentContent />
      </Permission>
    ),
  },
  // processReferenceDocumentPage: {
  //   isAdmin: true,
  //   title: 'Danh mục các quy định được tham chiếu trong mỗi tài liệu',
  //   path: '/statistic-reference-document',
  //   icon: <Icon.Compose />,
  //   component: processReferenceDocumentPage,
  // },
  // ImageToText
  // Task
  task: {
    isAdmin: false,
    title: "Công việc",
    path: "/task",
    icon: <Icon.Tasks />,
    component: () => "task",
  },
  // Setting
  setting: {
    isAdmin: true,
    title: "Cấu hình",
    path: "/setting",
    icon: <Icon.Setting />,
    component: () => <Redirect to={Routes.settingDocumentType.path} />,
  },
  settingDocument: {
    isAdmin: true,
    title: "Cấu hình Tài liệu",
    path: "/setting/document",
    icon: <Icon.Compose />,
    parentId: "setting",
    component: SettingDocumentPage,
  },
  settingDocumentPermission: {
    // isAdmin: true,
    title: "Phân quyền",
    path: "/setting/document/permission",
    icon: <Icon.Compose />,
    parentId: "setting",
    component: () => (
      <Permission permissions={[PERMISSIONS.SETTING_CONFIG]} role={["admin", "settings"]} fallback={<ForbiddenPage />}>
        <SettingDocumentPermissionPage />
      </Permission>
    ),
  },
  settingDocumentType: {
    // isAdmin: true,
    title: "Loại tài liệu",
    path: "/setting/document/type",
    icon: <Icon.Compose />,
    parentId: "setting",
    component: () => (
      <Permission permissions={[PERMISSIONS.SETTING_CONFIG]} role={["admin", "settings"]} fallback={<ForbiddenPage />}>
        <SettingDocumentTypePage />
      </Permission>
    ),
    // component: SettingDocumentTypePage,
  },
  settingDocumentDepartment: {
    // isAdmin: true,
    title: "Bộ phận phát hành",
    path: "/setting/document/department",
    icon: <Icon.Compose />,
    parentId: "setting",
    component: () => (
      <Permission permissions={[PERMISSIONS.SETTING_CONFIG]} role={["admin", "settings"]} fallback={<ForbiddenPage />}>
        <SettingDocumentDepartmentPage />
      </Permission>
    ),
    // component: SettingDocumentDepartmentPage,
  },
  settingMemberGroup: {
    // isAdmin: true,
    title: "Quản lý nhóm thành viên",
    path: "/setting/document/group",
    icon: <Icon.Channel />,
    parentId: "setting",
    component: () => (
      <Permission permissions={[PERMISSIONS.SETTING_CONFIG]} role={["admin", "settings"]} fallback={<ForbiddenPage />}>
        <SettingGroupPage />
      </Permission>
    ),
    // component: SettingGroupPage,
  },
  settingDecentralizationPage: {
    // isAdmin: true,
    title: "Phân quyền",
    path: "/setting/document/decentralization",
    icon: <Icon.Channel />,
    parentId: "setting",
    component: () => (
      <Permission
        permissions={[PERMISSIONS.ASSIGN_PERMISSION]}
        role={["admin", "settings"]}
        fallback={<ForbiddenPage />}
      >
        <SettingDecentralizationPageV2 />
      </Permission>
    ),
    // component: SettingDecentralizationPage,
  },
  settingDocumentTagType: {
    // isAdmin: true,
    title: "Chủ đề tài liệu",
    path: "/setting/document/document-tags",
    icon: <Icon.Channel />,
    parentId: "setting",
    component: documentTagsBox,
  },
  settingDepartmentList: {
    title: "Phòng ban",
    path: "/setting/document/departments",
    icon: <Icon.Tasks />,
    parentId: "setting",
    component: () => <DepartmentsPage />,
  },
  auth: {
    isAdmin: false,
    title: "auth/callback",
    path: "/auth/callback",
    icon: <Icon.Tasks />,
    component: () => "callback",
  },
  // CHAT ROUTES
  ...chatsRoutes,
  ...ViagsGptPageRoutes,
};

export const AppRoutes: FC = memo(() => {
  const { instance } = useMsal();
  const isUnauthorized = useSelector((state) => state.main.isUnauthorized);
  const { userAdmin } = useUser();
  const [isLoading, setIsLoading] = useState(false);
  const { setMineInfo } = useMineInfo();

  const memoizedRoutes = useMemo(() => Object.values(Routes), []);

  const memoizedRenderRoutes = useMemo(() => {
    return memoizedRoutes.map((item: any, key) => {
      if (item.isAdmin) item.isAdmin = userAdmin?.id ? userAdmin.id : 1;

      return (
        <Route
          key={key}
          exact
          path={item.path}
          component={(props: any) => {
            if (item.isAdmin) {
              return item.isAdmin !== 1 ? (
                <>
                  <item.component {...props} />
                  {!item.path.includes("document") && <BubbleChat />}
                </>
              ) : item.path === "/document" ? (
                <Redirect to={"/document?status=publish"} />
              ) : (
                <PageWarning />
              );
            } else
              return (
                <>
                  <item.component {...props} />
                  {!item.path.includes("document") && <BubbleChat />}
                </>
              );
          }}
        />
      );
    });
  }, [memoizedRoutes, userAdmin?.id]);

  const setMineInfoRef = useRef(setMineInfo);
  setMineInfoRef.current = setMineInfo;

  const instanceRef = useRef(instance);
  instanceRef.current = instance;

  const {
    rest: { isFetching: isFetchingSettingsPermission },
  } = useSettingsPermission();

  const fetchMineInfo = useCallback(async () => {
    try {
      const res = await UserService.getMineInfo();

      if (store.getState().user?.current?.accessToken)
        await UserService.signInByMsToken(store.getState().user.current.accessToken);

      setMineInfoRef.current(res || null);
    } catch (error) {
      message.error((error as Error)?.message || "Lỗi khi lấy thông tin người dùng");
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    if (isUnauthorized) instanceRef.current.handleRedirectPromise();
  }, [isUnauthorized]);

  useEffect(() => {
    if (isUnauthorized) fetchMineInfo();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (isLoading || isFetchingSettingsPermission) return <Spin size="large" />;

  return (
    <Router>
      <Suspense fallback={<FullscreenLoading />}>
        <Switch>
          {memoizedRenderRoutes}
          <Route component={Page404} />
        </Switch>
      </Suspense>
    </Router>
  );
});
